import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import store, { borrowerActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { BorrowerApi } from '@apply/api';
import { ConfirmModal } from '@apply/ui';
import { applicationInsights } from '../../ApplicationInsights';
import { LoadPanel } from 'devextreme-react/load-panel';
import { RefreshEvents } from '../../common/SharedEvents';
import { handleAdminError, handleAdminSuccess } from '../../common/SharedFunctions';

const DeleteBusinessToPrincipalLinkModal = () => {
    const { isOpen, companyId, principalId } = useSelector((state) => state.borrower.deleteBusinessToPrincipalLinkModal);
    const { dispatch } = store;
    const borrowerApi = new BorrowerApi.BorrowerApi(applicationInsights);
    const refreshEvents = new RefreshEvents();

    const [link, set_link] = useState(null);
    const [deletePrincipal, set_deletePrincipal] = useState(false);

    //Dialogs
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [loadingMessage, set_loadingMessage] = useState('Loading...');
    const [openConfirmDelete, set_openConfirmDelete] = useState(false);

    const handleClose = () =>
        dispatch(
            borrowerActions.setDeleteBusinessToPrincipalLinkModal({
                deleteBusinessPrincipalLinkModal: { isOpen: false },
            })
        );

    const styles = {
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        sectionHeader: { margin: '10px 0' },
        formColumn: { paddingBottom: '5px', paddingRight: '10px' },
    };

    const resetState = () => {
        set_link(null);
    };

    useEffect(() => {
        resetState();
    }, [isOpen]);

    useEffect(() => {
        if (!companyId || !principalId) {
            return;
        }

        const loadRelationshipAsync = async () => {
            const response = await borrowerApi.getBusinessPrincipalLinkSummary(companyId, principalId);
            if (response.statusCode !== 200) {
                return;
            }
            set_link(response.result);
        };
        loadRelationshipAsync();
    }, [companyId, principalId]);

    const confirmDelete = () => {
        if (deletePrincipal) {
            set_openConfirmDelete(true);
        } else {
            deleteBusinessPrincipalLink();
        }
    };

    const confirmMessage = () => {
        if (deletePrincipal) {
            return 'Are you sure you would like to delete the link and the relationship?';
        } else {
            return 'Are you sure you would like to delete the link?';
        }
    };

    const deleteBusinessPrincipalLink = async () => {
        try {
            set_loadingMessage('Saving changes...');
            set_loadingOpen(true);

            const model = {
                companyId,
                principalId,
                deletePrincipal,
            };
            const response = await borrowerApi.deleteBusinessPrincipalLink(model);
            if (response.statusCode !== 200) {
                return;
            }

            refreshEvents.dispatchRefreshEvent();

            handleAdminSuccess('Business-Contact link removed successfully.');
            set_loadingOpen(false);

            setTimeout(() => {
                handleClose();
            }, 600);
        } catch (ex) {
            set_loadingOpen(false);
            handleAdminError(ex, 'An unexpected error has occurred. Please try again.');
        }
    };

    const _handelConfirmCopy = async () => {
        await deleteBusinessPrincipalLink();
        set_openConfirmDelete(false);
    };

    const _handelCancelCopy = () => {
        set_openConfirmDelete(false);
    };

    if (!isOpen || !link) {
        return null;
    }

    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
            onClose={handleClose}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex='-1'
                    role='dialog'
                    style={{ width: '500px', overflow: 'unset' }}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <div
                            className='page-header'
                            role='banner'
                        >
                            <h1
                                style={{
                                    height: '50px',
                                    marginTop: '15px',
                                    flex: '0 0 80%',
                                    maxWidth: '80%',
                                }}
                            >
                                Remove Business-Principal Link
                            </h1>
                            <button
                                type='button'
                                className='close'
                                data-dismiss='modal'
                                aria-label='Close'
                                onClick={handleClose}
                            >
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                    </div>
                    <div
                        className='main-content no-search'
                        style={{ padding: '0', margin: '0' }}
                    >
                        <div style={{ padding: '10px' }}>
                            <div className='row'>
                                <div
                                    className='columns small-12 large-12'
                                    style={styles.formColumn}
                                >
                                    Are you sure you want to remove the link between:
                                </div>
                            </div>
                            <div
                                className='row'
                                style={{ textAlign: 'center', paddingTop: '15px' }}
                            >
                                <div
                                    className='columns small-12 large-12'
                                    style={styles.formColumn}
                                >
                                    <b>{link.companyName}</b>
                                </div>
                            </div>
                            <div
                                className='row'
                                style={{ textAlign: 'center' }}
                            >
                                <div
                                    className='columns small-12 large-12'
                                    style={styles.formColumn}
                                >
                                    and
                                </div>
                            </div>
                            <div
                                className='row'
                                style={{ textAlign: 'center' }}
                            >
                                <div
                                    className='columns small-12 large-12'
                                    style={styles.formColumn}
                                >
                                    <b>{link.principalName}</b>
                                </div>
                            </div>

                            {link.canRecyclePrincipal && (
                                <div className='row'>
                                    <div
                                        className='columns small-12 large-12'
                                        style={styles.formColumn}
                                    >
                                        <br />
                                        <input
                                            id={'deletePrincipal'}
                                            checked={deletePrincipal === true}
                                            onChange={(event) => set_deletePrincipal(event.target.checked)}
                                            type='checkbox'
                                        />{' '}
                                        Send Principal to Recycle Bin
                                    </div>
                                </div>
                            )}
                        </div>

                        <div
                            className='button-footer'
                            style={styles.buttonContainer}
                        >
                            <button
                                style={styles.buttonMarginRight}
                                type='button'
                                className='button primary'
                                title='Save changes and close this form'
                                disabled={!link}
                                onClick={confirmDelete}
                            >
                                Delete
                            </button>
                            &nbsp;
                            <button
                                type='button'
                                className='button hollow'
                                data-dismiss='modal'
                                onClick={handleClose}
                                title='Abandon changes and close'
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
            <ConfirmModal
                isOpen={openConfirmDelete}
                text={confirmMessage()}
                confirmCallback={_handelConfirmCopy}
                cancelCallback={_handelCancelCopy}
            />
        </Dialog>
    );
};

export default DeleteBusinessToPrincipalLinkModal;
